// Como o Início lê a agenda de hoje: grupos de status (cores do gráfico e
// legenda), duração de cada consulta e quem está na clínica agora.

export const LIVE_STATUSES = ['doing', 'waiting'];

export const STATUS_GROUPS = [
  { key: 'done', label: 'Realizadas', color: '#34C38F', statuses: ['completed'] },
  { key: 'live', label: 'Na clínica', color: '#5A80FB', statuses: LIVE_STATUSES },
  { key: 'confirmed', label: 'Confirmadas', color: '#A9BCFD', statuses: ['confirmed', 'confirmed_by_patient'] },
  { key: 'pending', label: 'A confirmar', color: '#F5B544', statuses: ['scheduled'] },
];

export const STATUS_LABELS = {
  scheduled: 'A confirmar',
  confirmed: 'Confirmada',
  confirmed_by_patient: 'Confirmada pelo paciente',
  waiting: 'Aguardando no local',
  doing: 'Em atendimento',
  completed: 'Realizada',
};

export function getStatusGroup(status) {
  return STATUS_GROUPS.find((g) => g.statuses.includes(status)) || STATUS_GROUPS[3];
}

/** Duração em minutos; o banco guarda "30" ou "00:30". */
export function getDurationMinutes(duration) {
  if (duration == null || duration === '') return 30;
  const text = String(duration);
  if (text.includes(':')) {
    const [h, m] = text.split(':').map(Number);
    return (h * 60 + m) || 30;
  }
  return Number(text) || 30;
}

/**
 * Quem está na clínica agora (em atendimento primeiro, depois aguardando) e
 * os próximos horários ainda não realizados (com 15 min de folga para atrasos).
 */
export function splitDay(appointments) {
  const open = appointments.filter((a) => a.status !== 'completed');
  const live = open
    .filter((a) => LIVE_STATUSES.includes(a.status))
    .sort((a, b) => (a.status === b.status ? 0 : a.status === 'doing' ? -1 : 1));
  const threshold = Date.now() - 15 * 60 * 1000;
  const upcoming = open.filter((a) => !LIVE_STATUSES.includes(a.status) && new Date(a.date).getTime() >= threshold);
  return { live, upcoming };
}
